<template>
  <v-container
    fluid
  >
    <v-row
      class="ma-0"
    >
      <v-col
        v-for="(order, idx) in flightOrders"
        :key="idx"
        cols="12"
        sm="12"
        md="6"
        lg="4"
        xl="4"
      >
        <FlightOrderCard
          :order.sync="order"
          @change="onOrderChange"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import {listFlightOrders} from "../../api/api-flight-provider"
  import FlightOrderCard from "./FlightOrderCard"
  import {findIndex} from "lodash/array"
  import {isEqual} from "lodash/lang"

  export default {
    name: "FlightOrders",
    components: {FlightOrderCard},
    data: () => ({
      flightOrders: []
    }),
    methods: {
      onOrderChange(order) {
        const idx = findIndex(this.flightOrders, item => isEqual(item["id_flight_order"], order["id_flight_order"]))
        if (idx !== -1) {
          this.flightOrders.splice(idx, 1, order)
        }
      }
    },
    mounted() {
      listFlightOrders(this.$apiAuth.getAuthToken())
        .then(res => {
          this.flightOrders = res.data.data
        })
    },
  }
</script>

